

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Button, Form, FormItem, Input, Radio, RadioGroup } from 'element-ui';
import { QuoteTemplateFields } from '@/types/graphql/schemaTypes.ts';
import rules from '@/rules/rules';

@Component({
  components: {
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-radio': Radio,
    'el-radio-group': RadioGroup
  }
})
export default class LoadTemplate extends Vue {
  @Prop({ default: false }) private open?: boolean;
  @Prop({ required: true }) private shipmentId?: string;
  private search = '';
  private inputForm = {
    select: null
  };

  private readonly rules = rules;

  $refs!: {
    loadTemplateForm: HTMLFormElement;
  };

  private closeModal() {
    this.search = '';
    this.reset();
    this.$emit('close');
  }

  private querySearch() {
    if (!this.search) {
      // eslint-disable-next-line no-unused-expressions
      this.$store.state.BillItem.quoteTemplates;
    }

    return this.$store.state.BillItem.quoteTemplates.filter((data: QuoteTemplateFields) => {
      return data.name.toLowerCase().includes(this.search.toLowerCase());
    });
  }

  private submit(): void {
    this.$refs.loadTemplateForm.validate((valid: boolean) => {
      if (!valid) {
        return;
      }

      this.$store.dispatch('BillItem/loadTemplate', {
        shipmentId: this.shipmentId,
        quoteTemplateId: this.inputForm.select
      }).then(() => {
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.added'),
          time: 2000
        });
        this.$emit('refresh');
        this.closeModal();
      });
    });
  }

  get filteredTemplate() {
    return this.querySearch();
  }

  @Watch('search')
  private reset() {
    this.$refs.loadTemplateForm.resetFields();
  }
}
